import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'newComment']
  static values = { user: String }

  connect() {
    // this.scrollToBottom()
  }

  containerTargetConnected(element) {
    setTimeout(() => {
      element.scrollTop = element.scrollHeight
    }, 100)
  }

  newCommentTargetConnected(element) {
    if (this.userValue === element.dataset.user) {
      element.classList.remove('them')
      element.classList.add('me')
    }
    this.scrollToBottom()
  }

  scrollToBottom() {
    if (this.hasContainerTarget) {
      this.containerTarget.scrollTop = this.containerTarget.scrollHeight
    }
  }
}